<template>
  <div>
    <logged-in-header />
    <product-combos-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import productCombosPanel from "../components/product-combo/ProductCombosPanel";

export default {
  components: {
    loggedInHeader,
    productCombosPanel
  }
};
</script>
